import React from 'react';
import { Link } from 'react-router-dom';

import { BrandLockup } from '../brand/Brand';
import { useSessionUserId } from '../../utils/session';

/**
 * The public pages' header (KPE-008): the lockup, home, on every public page.
 *
 * On the public SITE pages — the landing page, the legal pages, and later
 * Contact and Status — it also carries the way in: Docs, Sign in and Sign up
 * (one outlined button; the page below holds the one filled primary), or
 * Open keepr for someone already signed in. On a share link or a public form
 * it stays the bare wordmark: those pages are someone's records handed to a
 * visitor, and carry no account chrome (platform-standards §13.6).
 *
 * The landing page is prerendered with no session (scripts/prerender-public.mjs),
 * so its static HTML always says Sign in / Sign up; a signed-in visitor at `/`
 * never sees it (they get Home), and on every other public page this
 * component runs and reads the session.
 */
export default function PublicHeader({ site = false }) {
	const session = useSessionUserId();

	return (
		<header className="public-header">
			<div className="public-header__inner">
				<Link to="/" className="public-header__brand" aria-label="keepr home">
					<BrandLockup />
				</Link>
				{site ? (
					<nav className="public-header__nav" aria-label="Account">
						<Link to="/docs" className="public-header__link public-header__link--docs">Docs</Link>
						{session ? (
							<Link to="/" className="public-button">Open keepr</Link>
						) : (
							<>
								<Link to="/login" className="public-header__link">Sign in</Link>
								<Link to="/register" className="public-button">Sign up</Link>
							</>
						)}
					</nav>
				) : null}
			</div>
		</header>
	);
}
